export default "__VITE_ASSET__D6$F6r9M__"